const VQR_PASSWORD = 'dearpetal2026';
const VQR_KEY = 'dearpetal_videos';

let vqrVideos = [];
let vqrFilter = 'all';
let vqrSearchTerm = '';

function vqrLogin() {
  const pw = document.getElementById('vqr-password').value;
  if (pw === VQR_PASSWORD) {
    sessionStorage.setItem('vqr_auth', '1');
    document.getElementById('vqr-login-screen').style.display = 'none';
    document.getElementById('vqr-dashboard').style.display = 'block';
    vqrLoad();
  } else {
    document.getElementById('vqr-login-error').style.display = 'block';
  }
}

function vqrLogout() {
  sessionStorage.removeItem('vqr_auth');
  location.reload();
}

window.addEventListener('DOMContentLoaded', () => {
  if (sessionStorage.getItem('vqr_auth') === '1') {
    document.getElementById('vqr-login-screen').style.display = 'none';
    document.getElementById('vqr-dashboard').style.display = 'block';
    vqrLoad();
  }
});

function vqrLoad() {
  const stored = localStorage.getItem(VQR_KEY);
  vqrVideos = stored ? JSON.parse(stored) : [];
  vqrRender();
}

function vqrSave() {
  localStorage.setItem(VQR_KEY, JSON.stringify(vqrVideos));
}

function vqrUpload() {
  const name = document.getElementById('vqr-customer-name').value.trim();
  const order = document.getElementById('vqr-order-number').value.trim();
  const recipient = document.getElementById('vqr-recipient').value.trim();
  const note = document.getElementById('vqr-note').value.trim();
  const file = document.getElementById('vqr-file-input').files[0];

  if (!name) { vqrAlert('Please enter a customer name.', 'error'); return; }
  if (!file) { vqrAlert('Please select a video file.', 'error'); return; }

  if (file.size > 500 * 1024 * 1024) {
    vqrAlert('File too large. Maximum 500MB.', 'error');
    return;
  }

  document.getElementById('vqr-progress').style.display = 'block';
  document.getElementById('vqr-status').textContent = 'Reading video...';
  document.getElementById('vqr-progress-bar').style.width = '10%';

  const reader = new FileReader();

  reader.onprogress = (e) => {
    if (e.lengthComputable) {
      const pct = Math.round((e.loaded / e.total) * 80);
      document.getElementById('vqr-progress-bar').style.width = pct + '%';
    }
  };

  reader.onload = (e) => {
    document.getElementById('vqr-progress-bar').style.width = '90%';
    document.getElementById('vqr-status').textContent = 'Saving...';

    const id = 'vid_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

    const record = {
      id,
      customerName: name,
      orderNumber: order,
      recipient,
      note,
      fileName: file.name,
      fileSize: file.size,
      videoUrl: e.target.result,
      gdriveUrl: '',
      createdAt: new Date().toISOString(),
      printed: false,
    };

    vqrVideos.unshift(record);

    try {
      vqrSave();
    } catch(err) {
      vqrAlert('Storage getting full. Please delete old videos.', 'error');
    }

    document.getElementById('vqr-progress-bar').style.width = '100%';
    document.getElementById('vqr-status').textContent = 'Done! ✅';

    setTimeout(() => {
      document.getElementById('vqr-customer-name').value = '';
      document.getElementById('vqr-order-number').value = '';
      document.getElementById('vqr-recipient').value = '';
      document.getElementById('vqr-note').value = '';
      document.getElementById('vqr-file-input').value = '';
      document.getElementById('vqr-progress').style.display = 'none';
      document.getElementById('vqr-progress-bar').style.width = '0%';
      document.getElementById('vqr-status').textContent = '';
      vqrAlert('Video saved! Download it, upload to Google Drive, then paste the link to generate the QR code. 🌸', 'success');
      vqrRender();
    }, 800);
  };

  reader.onerror = () => {
    vqrAlert('Error reading file. Please try again.', 'error');
    document.getElementById('vqr-progress').style.display = 'none';
  };

  reader.readAsDataURL(file);
}

function vqrRender() {
  const grid = document.getElementById('vqr-grid');
  grid.innerHTML = '';

  let filtered = [...vqrVideos];

  if (vqrFilter === 'today') {
    const today = new Date().toDateString();
    filtered = filtered.filter(v =>
      new Date(v.createdAt).toDateString() === today
    );
  } else if (vqrFilter === 'week') {
    const week = new Date();
    week.setDate(week.getDate() - 7);
    filtered = filtered.filter(v => new Date(v.createdAt) >= week);
  }

  if (vqrSearchTerm) {
    const s = vqrSearchTerm.toLowerCase();
    filtered = filtered.filter(v =>
      v.customerName.toLowerCase().includes(s) ||
      (v.orderNumber && v.orderNumber.toLowerCase().includes(s)) ||
      (v.recipient && v.recipient.toLowerCase().includes(s))
    );
  }

  if (filtered.length === 0) {
    grid.innerHTML = `
      <div class="vqr-empty">
        <h3>No videos found</h3>
        <p>Upload your first video above to get started 🌸</p>
      </div>`;
    return;
  }

  filtered.forEach(v => {
    const card = document.createElement('div');
    card.className = 'vqr-card';

    const date = new Date(v.createdAt).toLocaleDateString('en-AU', {
      day: 'numeric', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });

    const hasGdriveUrl = v.gdriveUrl && v.gdriveUrl.trim() !== '';
    const hasVideo = v.videoUrl && v.videoUrl.trim() !== '';

    card.innerHTML = `
      <div class="vqr-card-top">
        <div class="vqr-card-info">
          <h3>${v.customerName}</h3>
          <p>${v.orderNumber ? '#' + v.orderNumber + ' · ' : ''}${date}</p>
          ${v.recipient ? '<p>For: <strong>' + v.recipient + '</strong></p>' : ''}
          ${v.printed ? '<span class="vqr-badge">✓ Printed</span>' : ''}
        </div>
      </div>

      ${hasVideo ? '<video class="vqr-video-preview" src="' + v.videoUrl + '" controls preload="metadata"></video>' : ''}

      <div class="vqr-qr-wrap" id="qr-${v.id}">
        ${!hasGdriveUrl ? '<p style="font-size:0.75rem;color:#aaa;text-align:center;padding:10px;">Paste Google Drive link below to generate QR code</p>' : ''}
      </div>

      ${v.note ? '<p style="font-size:0.8rem;color:#888;margin-bottom:10px;">📝 ' + v.note + '</p>' : ''}

      <div style="margin-bottom:12px;">
        <label style="font-size:0.8rem;font-weight:600;color:#555;display:block;margin-bottom:6px;">
          📎 Step 1 — Download video and upload to Google Drive, then paste the link here
        </label>
        <div style="display:flex;gap:8px;">
          <input
            type="text"
            id="gdrive-${v.id}"
            placeholder="https://drive.google.com/file/d/..."
            value="${v.gdriveUrl || ''}"
            style="flex:1;padding:8px 12px;border:1px solid #ddd;border-radius:8px;font-size:0.85rem;outline:none;"
          />
          <button class="vqr-btn-sm" onclick="vqrSaveGdriveUrl('${v.id}')">Save and Generate QR</button>
        </div>
      </div>

      <div class="vqr-card-actions">
        ${hasVideo ? '<button class="vqr-btn-sm" onclick="vqrDownload(\'' + v.id + '\')">⬇️ Download Video</button>' : ''}
        <button
          class="vqr-btn-print"
          onclick="vqrPrintSingle('${v.id}')"
          ${!hasGdriveUrl ? 'disabled style="opacity:0.4;cursor:not-allowed;background:#999;"' : ''}
        >🖨️ Print QR</button>
        <button class="vqr-btn-sm" onclick="vqrMarkPrinted('${v.id}')">✓ Mark Printed</button>
        <button class="vqr-btn-danger" onclick="vqrDelete('${v.id}')">🗑 Delete</button>
      </div>
    `;

    grid.appendChild(card);

    if (hasGdriveUrl) {
      setTimeout(() => {
        const qrEl = document.getElementById('qr-' + v.id);
        if (qrEl && typeof QRCode !== 'undefined') {
          qrEl.innerHTML = '';
          try {
            new QRCode(qrEl, {
              text: v.gdriveUrl,
              width: 160,
              height: 160,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.M
            });
          } catch(e) {
            qrEl.innerHTML = '<p style="font-size:0.75rem;color:#888;text-align:center;">QR generation failed. Try a shorter URL.</p>';
          }
        }
      }, 200);
    }
  });
}

function vqrDownload(id) {
  const v = vqrVideos.find(x => x.id === id);
  if (!v || !v.videoUrl) return;
  const a = document.createElement('a');
  a.href = v.videoUrl;
  a.download = v.fileName || 'video.mp4';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

function vqrSaveGdriveUrl(id) {
  const input = document.getElementById('gdrive-' + id);
  if (!input) return;
  const url = input.value.trim();
  if (!url) { vqrAlert('Please paste a Google Drive link first.', 'error'); return; }

  const v = vqrVideos.find(x => x.id === id);
  if (v) {
    v.gdriveUrl = url;
    vqrSave();
    vqrAlert('Google Drive link saved! QR code generated. 🌸', 'success');
    vqrRender();
  }
}

function vqrTab(tab, el) {
  vqrFilter = tab;
  document.querySelectorAll('.vqr-tab').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
  vqrRender();
}

function vqrSearch() {
  vqrSearchTerm = document.getElementById('vqr-search').value;
  vqrRender();
}

function vqrPrintSingle(id) {
  const v = vqrVideos.find(x => x.id === id);
  if (!v || !v.gdriveUrl) {
    vqrAlert('Please add a Google Drive link first to generate the QR code.', 'error');
    return;
  }

  const pw = window.open('', '_blank', 'width=400,height=450');
  pw.document.write(`<!DOCTYPE html>
<html>
<head>
  <title>QR - ${v.customerName}</title>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"><\/script>
  <style>
    body{margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh;background:#fff;font-family:Arial;}
    .wrap{width:5cm;height:5cm;display:flex;flex-direction:column;align-items:center;justify-content:center;border:1px solid #ccc;padding:0.2cm;}
    p{font-size:7pt;text-align:center;margin-top:3pt;color:#333;max-width:4.5cm;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    @media print{body{margin:0;}}
  </style>
</head>
<body>
  <div class="wrap">
    <div id="qr"></div>
    <p>${v.customerName}${v.recipient ? ' → ' + v.recipient : ''}</p>
    ${v.orderNumber ? '<p>#' + v.orderNumber + '</p>' : ''}
  </div>
  <script>
    window.onload=function(){
      new QRCode(document.getElementById('qr'),{
        text:${JSON.stringify(v.gdriveUrl)},
        width:132,height:132,
        colorDark:'#000000',colorLight:'#ffffff',
        correctLevel:QRCode.CorrectLevel.M
      });
      setTimeout(function(){window.print();},800);
    };
  <\/script>
</body>
</html>`);
  pw.document.close();
  vqrMarkPrinted(id, true);
}

function vqrPrintAll() {
  const unprinted = vqrVideos.filter(v => !v.printed && v.gdriveUrl);
  if (unprinted.length === 0) {
    vqrAlert('No unprinted QR codes with Google Drive links. Add Drive links first.', 'error');
    return;
  }

  const pw = window.open('', '_blank', 'width=800,height=600');

  const items = unprinted.map(v => `
    <div class="item">
      <div id="qr-${v.id}"></div>
      <p>${v.customerName}${v.recipient ? ' → ' + v.recipient : ''}</p>
      ${v.orderNumber ? '<p>#' + v.orderNumber + '</p>' : ''}
    </div>`).join('');

  const scripts = unprinted.map(v => `
    new QRCode(document.getElementById('qr-${v.id}'),{
      text:${JSON.stringify(v.gdriveUrl)},
      width:132,height:132,
      colorDark:'#000000',colorLight:'#ffffff',
      correctLevel:QRCode.CorrectLevel.M
    });`).join('\n');

  pw.document.write(`<!DOCTYPE html>
<html>
<head>
  <title>QR Codes - Dear Petal</title>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"><\/script>
  <style>
    body{margin:1cm;font-family:Arial;}
    h2{font-size:12pt;margin-bottom:0.5cm;}
    .grid{display:grid;grid-template-columns:repeat(4,5cm);gap:0.3cm;}
    .item{width:5cm;height:5cm;display:flex;flex-direction:column;align-items:center;justify-content:center;border:1px solid #ccc;padding:0.2cm;page-break-inside:avoid;}
    p{font-size:7pt;text-align:center;margin-top:3pt;color:#333;max-width:4.5cm;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    @media print{body{margin:0.5cm;}h2{display:none;}}
  </style>
</head>
<body>
  <h2>🌸 Dear Petal QR Codes — ${unprinted.length} to print</h2>
  <div class="grid">${items}</div>
  <script>
    window.onload=function(){
      ${scripts}
      setTimeout(function(){window.print();},1000);
    };
  <\/script>
</body>
</html>`);
  pw.document.close();

  unprinted.forEach(v => vqrMarkPrinted(v.id, true));
  vqrSave();
  vqrAlert(unprinted.length + ' QR codes sent to printer! 🌸', 'success');
  vqrRender();
}

function vqrMarkPrinted(id, silent = false) {
  const v = vqrVideos.find(x => x.id === id);
  if (v) {
    v.printed = true;
    vqrSave();
    if (!silent) {
      vqrAlert('Marked as printed ✓', 'success');
      vqrRender();
    }
  }
}

function vqrDelete(id) {
  if (!confirm('Delete this video and QR code? This cannot be undone.')) return;
  vqrVideos = vqrVideos.filter(v => v.id !== id);
  vqrSave();
  vqrRender();
  vqrAlert('Video deleted.', 'success');
}

function vqrAlert(msg, type) {
  const el = document.getElementById('vqr-alert');
  el.className = 'vqr-alert vqr-alert-' + type;
  el.textContent = msg;
  el.style.display = 'block';
  setTimeout(() => { el.style.display = 'none'; }, 5000);
}

function dpMarkVideoStarted() {
  sessionStorage.setItem('dp_video_started', '1');
}